export function formatDate(date) {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (day < 10) day = `0${day}`;
  if (month < 10) month = `0${month}`;

  return [year, month, day].join('-');
}

export function parseDate(str) {
  const yearMonthDay = str.split('-');
  const date = new Date(yearMonthDay[0], yearMonthDay[1] - 1, yearMonthDay[2]);
  return date;
}
